import axiosInstance from "./axiosService";
import serverUrl from "../config/serverUrl";

const API_URL = `${serverUrl}/admin`;
const BLOG_API_URL = `${serverUrl}/blogs`;

export const getStats = async () => {
  try {
    const response = await axiosInstance.get(`${API_URL}/stats`);
    return response.data;
  } catch (error) {
    console.log(error);
    throw error.response.data;
  }
};

export const getOrders = async (page = 1, limit = 10, search = "") => {
  try {
    const response = await axiosInstance.get(
      `${API_URL}/orders?page=${page}&limit=${limit}&search=${search}`,
    );
    return response.data;
  } catch (error) {
    console.log(error);
    throw error.response.data;
  }
};

export const getProducts = async (page = 1, limit = 10, search = "") => {
  try {
    const response = await axiosInstance.get(
      `${API_URL}/products?page=${page}&limit=${limit}&search=${search}`,
    );
    return response.data;
  } catch (error) {
    console.log(error);
    throw error.response.data;
  }
};

export const updateProducts = async (productId, formData) => {
  try {
    const response = await axiosInstance.put(
      `${API_URL}/products/${productId}`,
      formData,
    );
    return response.data;
  } catch (error) {
    console.log(error);
    throw error.response.data;
  }
};

export const getProductById = async (id) => {
  try {
    const response = await axiosInstance.get(`${API_URL}/products/${id}`);
    return response.data;
  } catch (error) {
    console.log(error);
    throw error.response.data;
  }
};

export const getUsers = async (page = 1, limit = 10, search = "") => {
  try {
    const response = await axiosInstance.get(
      `${API_URL}/users?page=${page}&limit=${limit}&search=${search}`,
    );
    return response.data;
  } catch (error) {
    console.log(error);
    throw error.response.data;
  }
};

export const updateOrderStatus = async (orderId, data) => {
  try {
    const response = await axiosInstance.put(
      `${API_URL}/orders/${orderId}/status`,
      data,
    );
    return response.data;
  } catch (error) {
    console.log(error);
    throw error.response?.data || error;
  }
};

export const getOrderById = async (orderId) => {
  try {
    const response = await axiosInstance.get(`${API_URL}/orders/${orderId}`);
    return response.data;
  } catch (error) {
    console.log(error);
    throw error.response?.data || error;
  }
};

export const addProduct = async (data) => {
  try {
    const response = await axiosInstance.post(`${API_URL}/products`, data);
    return response.data;
  } catch (error) {
    console.log(error);
    throw error.response.data;
  }
};

export const deleteProduct = async (id) => {
  try {
    const response = await axiosInstance.delete(`${API_URL}/products/${id}`);
    return response.data;
  } catch (error) {
    console.log(error);
    throw error.response.data;
  }
};

// Blog Services
export const getAdminBlogs = async (page = 1, limit = 10, search = "") => {
  try {
    const response = await axiosInstance.get(
      `${BLOG_API_URL}?page=${page}&limit=${limit}&search=${search}&admin=true`,
    );
    return response.data;
  } catch (error) {
    console.log(error);
    throw error.response.data;
  }
};

export const addBlog = async (data) => {
  try {
    const response = await axiosInstance.post(`${BLOG_API_URL}`, data);
    return response.data;
  } catch (error) {
    console.log(error);
    throw error.response.data;
  }
};

export const updateBlog = async (id, data) => {
  try {
    const response = await axiosInstance.put(`${BLOG_API_URL}/${id}`, data);
    return response.data;
  } catch (error) {
    console.log(error);
    throw error.response.data;
  }
};

export const deleteBlog = async (id) => {
  try {
    const response = await axiosInstance.delete(`${BLOG_API_URL}/${id}`);
    return response.data;
  } catch (error) {
    console.log(error);
    throw error.response.data;
  }
};
